import { publicAxios } from "../lib/axios";
export default {
  namespaced: true,
  state: {
    fakeusers: [],
    fakeID: 4
  },
  mutations: {
    carregarCondicoesPagamento(state) {
      try {
        publicAxios
          .get("/condicoes-pagamento")
          .then(response => (state.fakeusers = response.data));

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    gravarCondicoesPagamento(state) {
      state.fakeID++;
    },
    buscarCondicoesPagamento(state, response) {
      state.fakeusers = response;
    }
  },
  actions: {
    listar(context) {
      context.commit("carregarCondicoesPagamento");
    },
    buscar(context, aFiltro) {
      try {
        var filtro = aFiltro.filtro ? aFiltro.filtro : "";
        var valor = aFiltro.valor ? aFiltro.valor : "";

        publicAxios
          .get("/condicoes-pagamento?" + filtro + "=" + valor)
          .then(response => context.commit("buscarCondicoesPagamento", response.data));

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    gravar(context, condicaoPagamentoInfo) {
      try {
        var id = condicaoPagamentoInfo.id;

        if (id == "") {
          var infoNovo = {
            descricao: condicaoPagamentoInfo.descricao,
            parcelas: "{" + condicaoPagamentoInfo.parcelas + "}"
          };
          publicAxios.post("/condicoes-pagamento", infoNovo);
          context.commit("gravarCondicoesPagamento");
        } else {
          var infoAltera = {
            descricao: condicaoPagamentoInfo.descricao,
            parcelas: "{" + condicaoPagamentoInfo.parcelas + "}"
          };
          publicAxios.put("/condicoes-pagamento/" + id, infoAltera);
          context.commit("gravarCondicoesPagamento");
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    deletar(context, id) {
      try {
        publicAxios.delete("/condicoes-pagamento/" + id.id);
        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarCondicoesPagamento(context, id) {
      try {
        const response = publicAxios.get("/condicoes-pagamento/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    }
  }
};
